import React, { useState } from 'react'
import Admin from './admins/Admin'
import AdminTable from './admins/AdminTable'
import CreateAdmin from './admins/CreateAdmin'
import ConsumersTable from './consumers/ConsumersTable'
import Reseller from './resellers/Reseller'
import ResellersTable from './resellers/ResellersTable'
import CreateReseller from './resellers/CreateReseller'
import { Container, Menu, MenuItem } from 'semantic-ui-react'

const Users = () => {
    const [activeItem, setActiveItem] = useState('resellers')
    const [adminToEdit, setAdminToEdit] = useState({})
    const [resellerToEdit, setResellerToEdit] = useState({})

    const renderContent = () => {
        switch (activeItem) {
            case 'resellers':
                return <ResellersTable onChangeItem={handleChangeItemReseller} />
            case 'new-reseller':
                return <CreateReseller goBack={handleBackClickedResellers} />
            case 'edit-reseller':
                return <Reseller reseller={resellerToEdit} goBack={handleBackClickedResellers} />
            case 'consumers':
                return <ConsumersTable/>
            case 'admins':
                return <AdminTable onChangeItem={handleChangeItemAdmin} />
            case 'new-admin':
                return <CreateAdmin goBack={handleBackClickedAdmins} />
            case 'edit-admin':
                return <Admin admin={adminToEdit} goBack={handleBackClickedAdmins} />
            default:
                return
        }
    }

    const handleMenuItemClicked = e => {
        switch (e.target.innerText) {
            case 'Resellers':
                setActiveItem('resellers')
                break
            case 'Consumers':
                setActiveItem('consumers')
                break
            case 'Admins':
                setActiveItem('admins')
                break
            default:
                break
        }
    }

    const handleChangeItemAdmin = (item, admin) => {
        if (admin && item === 'edit-admin') setAdminToEdit(admin)
        setActiveItem(item)
    }
    const handleChangeItemReseller = (item, reseller) => {
        if (reseller && item === 'edit-reseller') setResellerToEdit(reseller)
        setActiveItem(item)
    }
    const handleBackClickedAdmins = () => {
        setActiveItem('admins')
    }
    const handleBackClickedResellers = () => {
        setActiveItem('resellers')
    }

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            <Menu size={window.innerWidth < 768 ? 'mini' : null } inverted pointing secondary>
                <MenuItem name='resellers' active={activeItem === 'resellers' || activeItem === 'new-reseller' || activeItem === 'edit-reseller'} onClick={handleMenuItemClicked}/>
                <MenuItem name='consumers' active={activeItem === 'consumers'} onClick={handleMenuItemClicked}/>
                <MenuItem name='admins' active={activeItem === 'admins' || activeItem === 'new-admin' || activeItem === 'edit-admin'} onClick={handleMenuItemClicked}/>
            </Menu>
            {renderContent()}
        </Container>
    )
}

export default Users